export enum ResetPasswordError {
  ExpiredCode,
  CodeAlreadyUsed,
  InvalidCode,
  Unknown
}
